import {
  AppSelect,
  TOption,
} from '../../../components/appSelect';
import responsiveLayoutLogo from '../../../assets/icons/responsive_layout.svg';

type TProps = {
  selectedValue: string;
  onChange: (val: string) => void;
};

export const ASPECT_RATIO_OPTIONS: TOption[] = [
  {
    value: '1:1',
    label: 'Square',
    icon: (
      <div className="option_icon w-[24px] h-[24px]">
        1:1
      </div>
    ),
  },
  {
    value: '3:4',
    label: 'Portrait',
    icon: (
      <div className="option_icon w-[18px] h-[24px]">
        3:4
      </div>
    ),
  },
  {
    value: '4:3',
    label: 'Landscape',
    icon: (
      <div className="option_icon w-[24px] h-[18px]">
        4:3
      </div>
    ),
  },
  {
    value: '16:9',
    label: 'Wide',
    icon: (
      <div className="option_icon w-[28px] h-[16px]">
        16:9
      </div>
    ),
  },
  {
    value: '9:16',
    label: 'Tall',
    icon: (
      <div className="option_icon w-[20px] h-[28px]">
        9:16
      </div>
    ),
  },
];

const OPTIONS = ASPECT_RATIO_OPTIONS;

export const AspectRatio = ({
  selectedValue,
  onChange,
}: TProps) => {
  return (
    <AppSelect
      label="Aspect Ratio"
      selectIcon={responsiveLayoutLogo}
      selectedValue={selectedValue}
      onChange={onChange}
      options={OPTIONS}
    />
  );
};
